<template>
    <v-app-bar app color="primary" dark>
        <div class="d-flex align-center">
            <span id="header-logo" class="pointer" @click="goHome">tenpredict</span>
        </div>

        <v-spacer></v-spacer>
        <div v-if="showSizey">{{ sizey }}</div>
        <v-spacer v-if="showSizey"></v-spacer>

        <div class="text-center" v-if="loggedIn">
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="secondary" small rounded v-bind="attrs" v-on="on">
                        Hi {{ user.username }}<v-icon right dark>mdi-menu-down</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                            v-for="(item, index) in items"
                            :key="index"
                            @click="handleClick"
                    >
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>

        <v-btn color="secondary" to="/login" v-if="!loggedIn">Log In</v-btn>

    </v-app-bar>
</template>

<script>
  import { helpers } from "../store/helpers";

  export default {
    name: "TopBar",
    data: () => ({
      items: [
        {
          title: 'Preferences',
          ref: 'prefs'
        },
        {
          title: 'Logout',
          ref: 'logout'
        },
      ],
    }),
    computed: {
      ...helpers,
      sizey() {
        return this.$vuetify.breakpoint.name;
      },
      showSizey() {
        if (this.user && this.user.id === 1 && this.user.username === 'rob') {
          return true;
        }
        return false;
      }
    },
    methods: {
      handleClick(e) {
        const method = e.target.innerText;
        switch (method) {
          case 'Logout':
            this.logout();
            break;
          case 'Preferences':
            this.goToPrefs();
            break;
        }
      },
      logout() {
        this.$store.dispatch('logout')
      },
      goToPrefs() {
        this.$router.push({ name: 'Preferences' })
      },
      goHome() {
        this.$router.push({ name: 'Home' })
      }
    }
  }
</script>

<style scoped>

    #header-logo {
        font-family: "Montserrat-Regular";
        font-size: 1.8rem;
        color: black;
    }

    .pointer {
        cursor: pointer;
    }

</style>
